import { createRoot, type Root } from "react-dom/client";
import type { RenderOptions } from "./types";

export type FacetData = {
  [facet: string]: {
    order: string[];
    sortRemainingBy: "hidden" | "count" | "alpha";
  };
};

function normalize(item: string): string {
  return item.toLowerCase().replace(/-/g, " ").replace(/\s/g, "");
}

export function generateFilterQuery(data: FacetData, slug: string): string {
  let category = null;
  let originalCaseValue = null;

  for (const [key, details] of Object.entries(data)) {
    const foundItem = details.order.find(
      (item) => normalize(item) == normalize(slug)
    );

    if (foundItem) {
      category = key;
      originalCaseValue = foundItem;
      break;
    }
  }

  if (category && originalCaseValue) {
    return `${category}:"${originalCaseValue}"`;
  } else {
    return "Value not found in the object";
  }
}

type RenderWithExtraArgumentsArgs = {
  extraArguments: unknown[];

  renderer: (...args: unknown[]) => void;
};

export const renderWithExtraArguments = ({
  renderer,
  extraArguments,
}: RenderWithExtraArgumentsArgs) => {
  return (renderOptions: RenderOptions, isFirstRender: unknown) => {
    renderer(renderOptions, isFirstRender, ...extraArguments);
  };
};

export function createUniqueRoot(
  element: Element & { reactRootReference?: Root }
) {
  if (!element.reactRootReference) {
    element.reactRootReference = createRoot(element);
  }
  return element.reactRootReference;
}
